import { v4 as uuidv4 } from 'uuid'

export const businessLocationTestData = () => {
  return {
    title: 'Location',
    item: 'City name, state',
    key: uuidv4()
  }
}
